import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import config from '../config'
import Cookies from 'js-cookie'

export const webConfigApi = createApi({
  reducerPath: 'webConfigApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiAdminGateway,
    prepareHeaders: (headers, { getState }) => {
      const token = Cookies.get('accessToken')
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  endpoints: (builder) => ({
    getWebConfig: builder.query({
      query: () => `/api/v1/admin/configs`,
      transformResponse: (response) => {
        return response.data
      },
    }),
  }),
})
export const { useGetWebConfigQuery } = webConfigApi
